export default __webpack_public_path__ + "static/media/forgotpwd.be275426.jpg";